"use client";
import { permissions } from "@/utils/constants";
import { useMe } from "@/utils/hooks/useMe";
import { Result } from "antd";
import React, { PropsWithChildren, ReactNode } from "react";

import styles from "./index.module.scss";

interface Props extends PropsWithChildren {
  permission: (typeof permissions)[number];
  show403?: boolean;
  replacement?: ReactNode;
}

function PermissionContainer({
  show403,
  permission,
  children,
  replacement,
}: Props) {
  const { data: user } = useMe();
  const permissions = user?.payload.permissions ?? [];
  const hasPermission =
    permissions.includes(permission) || permissions.includes("manage:all");
  if (!hasPermission)
    if (show403)
      return (
        <Result
          className={styles.result}
          status="403"
          title="Oops…"
          subTitle="Sorry, you are not authorized to access here"
          style={{ marginTop: 60 }}
        />
      );
    else if (replacement) return replacement;
    else return <></>;
  return children;
}

export default PermissionContainer;
